// extracted by mini-css-extract-plugin
module.exports = {"background":"SearchWidget_background__190hA","backgroundClickSurface":"SearchWidget_backgroundClickSurface__2Vwlj"};